<div class="hidden lg:flex w-full gap-2 items-center flex-wrap justify-between mb-3">
  <div class="flex gap-2 items-center flex-wrap">
    @for (filterConfig of filterConfigs(); track filterConfig.name) {
      <proffeo-ui-select
        (valueChange)="onFilterValueChange(filterConfig.name, $event)"
        [label]="filterConfig.placeholder"
        [multiple]="filterConfig.multiple"
        [options]="filterConfig.items"
        [proffeoFilterCountBadge]="getFilterBadgeCount(filterConfig.name)"
        [searchable]="true"
        [selectAllLabel]="'placeholders.select-all'"
        [translateLabels]="false"
        [triggerDisplay]="'full'"
        [value]="getFilterValue(filterConfig.name)"
        class="max-w-50 flex"
      />
    }
  </div>

  <proffeo-ui-button
    (clicked)="clearFilters()"
    text="time-reports-filters.clear-filters"
  />
</div>
